function openQQ(oneself,heart){
    let qq= "1730933627";
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|wOSBrowser|BrowserNG|WebOS)/i))) {
        if(oneself){
            window.location.href = `mqqwpa://im/chat?chat_type=wpa&uin=${qq}&version=1&src_type=web&web_src=oicqzone.com`;
        }else{
            if(heart){
                window.location.href = `mqqapi://card/show_pslcard?src_type=internal&version=1&uin=1072536772&card_type=group&source=qrcode`;
            }else{
                window.location.href = `mqqapi://card/show_pslcard?src_type=internal&version=1&uin=118661154&card_type=group&source=qrcode`;
            }
        }
    }
    else {
        if(oneself){
            window.location.href = `tencent://message/?uin=${qq}`;
        }else{
            if(heart){
                window.open("https://qm.qq.com/cgi-bin/qm/qr?k=rbLp0TZQQcm17FugQ8poSAMLswxKRANP&jump_from=webapi&authKey=Cuilq+7jHy0ijAJBgxDgRV4iT07NMUl8Hw+DEd4qiK24rr7NeL6fJPDZm9aLocFG","_blank");
            }else{
                window.open("https://qm.qq.com/cgi-bin/qm/qr?k=ccc2R9YXLkAUyGtZ2TLOpATF-4tNcGn3&jump_from=webapi&authKey=vpzvTSxg+157zeeyTUcbUhqeaR05aAlUpNRYopv1RNHZb5qc30xCLd1C8D9QH0tb","_blank");
            }
        }
    }
}

export default openQQ